// project import
import menuConfig from './config';

// ==============================|| MENU ITEMS ||============================== //

// subgroup çocuklarına da (iç içe, örn. Raporlar) recursive iner; rol
// eşleşmesi kalmayan subgroup/grup listeden tamamen düşer
function filterChildren(children, kullaniciTipi) {
  return children
    .map((child) => {
      if (child.type === 'subgroup') {
        const subChildren = filterChildren(child.children, kullaniciTipi);
        return subChildren.length ? { ...child, children: subChildren } : null;
      }
      return !child.roles || child.roles.includes(kullaniciTipi) ? child : null;
    })
    .filter(Boolean);
}

function filterByRole(groups, kullaniciTipi) {
  return groups
    .map((group) => {
      const children = filterChildren(group.children, kullaniciTipi);
      return children.length ? { ...group, children } : null;
    })
    .filter(Boolean);
}

// Navigation bileşeni kullaniciTipi'ne göre görünür menü ögelerini bu fonksiyondan alır.
export function getMenuItems(kullaniciTipi) {
  return { items: filterByRole(menuConfig, kullaniciTipi) };
}

// Breadcrumbs gibi rol filtresine ihtiyaç duymayan (sadece başlık/ikon eşleştiren)
// tüketiciler için geriye dönük uyumluluk amacıyla filtrelenmemiş tam ağaç.
const menuItems = { items: menuConfig };

export default menuItems;
